export default __webpack_public_path__ + "static/media/rectangle-area.5a801cb4.svg";